/* eslint-disable no-empty, no-restricted-globals */

function getContainerData(container) {
  const postType = container.getAttribute('data-more');
  const page = container.hasAttribute('data-page')
    ? parseInt(container.getAttribute('data-page'), 10)
    : 1;
  const postsPerPage = container.hasAttribute('data-per-page')
    ? parseInt(container.getAttribute('data-per-page'), 10)
    : 9;
  const button = container.querySelector(container.getAttribute('data-button'));
  const dataContainer = container.querySelector(
    container.getAttribute('data-container'),
  );

  const data = {
    info: {
      postType,
      page,
      postsPerPage,
    },
    button,
    dataContainer,
    container,
  };

  if (container.hasAttribute('data-per-page-mobile')) {
    data.info.postsPerPageMobile = parseInt(
      container.getAttribute('data-per-page-mobile'),
      10,
    );
  }

  if (container.hasAttribute('data-category-id')) {
    data.info.categoryId = parseInt(
      container.getAttribute('data-category-id'),
      10,
    );
  }

  return data;
}

function loadData(options) {
  if (
    typeof options !== 'object' ||
    options.data === undefined ||
    options.url === undefined
  ) {
    return;
  }

  const xhr = new XMLHttpRequest();

  xhr.open('POST', options.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.onload = () => {
    if (xhr.status === 200 && xhr.responseText) {
      if (typeof options.success === 'function') {
        options.success(xhr.responseText);
      }
    }
    if (typeof options.always === 'function') {
      options.always();
    }
  };

  const keys = Object.keys(options.data);
  let parameters = `action=more&token=${new Date().getTime()}`;

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    parameters += `&${key}=${encodeURIComponent(options.data[key])}`;
  }
  xhr.send(parameters);
}

function loadMorePosts(options) {
  if (typeof options !== 'object' || options.button === undefined) {
    return;
  }

  const { button } = options;

  if (button.hasAttribute('data-loading')) {
    return;
  }

  const defaultText = button.textContent;
  const { dataContainer } = options;
  const { container } = options;
  const token = new Date().getTime();
  container.setAttribute('data-token', token);

  button.setAttribute('data-loading', '');
  button.textContent = 'Loading...';

  loadData({
    data: options.info,
    url: window.ELEFINT.ajaxURL,
    always: () => {
      button.removeAttribute('data-loading');
      button.textContent = defaultText;

      if (typeof options.always === 'function') {
        options.always();
      }
    },
    success: data => {
      const currentToken = parseInt(container.getAttribute('data-token'), 10);

      if (currentToken !== token) {
        return;
      }

      try {
        const json = JSON.parse(data);
        dataContainer.innerHTML += json.posts;
        container.setAttribute('data-page', options.info.page);

        if (json.hasMore === false) {
          container.classList.add('no-more-button');
        } else {
          container.classList.remove('no-more-button');
        }
      } catch (e) {}

      if (typeof options.success === 'function') {
        options.success(data);
      }
    },
  });
}

export { getContainerData, loadMorePosts, loadData };



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/helpers/more.js